<button
  class="filter-toggle"
  (click)="toggleFilters.emit()"
  cignaButton="link"
  data-test="filters-bar-button"
>
  <span>Filters</span>
  <cigna-icon class="cg-margin-left-xs" type="caret-down"></cigna-icon>
</button>

<section
  class="cg-margin-top-md"
  [ngClass]="{ expanded: isExpanded }"
  data-test="filters-bar"
>
  <ng-content></ng-content>
</section>

<div *ngIf="isExpanded" class="cg-button-group cg-margin-bottom-md">
  <button
    (click)="applyFilters.emit()"
    cignaButton="primary"
    [disabled]="!isValid"
    data-test="filters-apply"
  >
    Apply
  </button>
  <button
    class="reset"
    (click)="resetFilters.emit()"
    cignaButton="link inline no-underline"
    data-test="filters-reset"
  >
    Reset
  </button>
</div>
